// extracted by mini-css-extract-plugin
module.exports = {"container":"SfUKxxJ0","pillWrapper":"IM5lmLSk","title":"miZdtYbN","loaderWrapper":"hvdY9Vxh","wrapper":"ePs6EPKx"};